<template>
  <div id="mediahero">
    <div class="texts">
      <div class="text1">
        <p>Descoperă trainingul care ți se potrivește</p>
      </div>
      <div class="text2">
        <p>Ce anume dorești să-ti dezvolți?</p>
      </div>
    </div>
    <div class="flex-container">
      <div class="content">
        <span>
          Career
          <br />Development
        </span>
      </div>
      <div class="selection">
        <div class="textsMobile">
          <div class="text1M">
            <p>Find the workshop that works for you</p>
          </div>
          <div class="text2M">
            <p>What skills would you like to upgrade?</p>
          </div>
        </div>
        <SelectButton
          class="select2"
          :config="workshops"
          @setSelectedOption="setWorkshop($event);"
        ></SelectButton>
        <SelectButton
          class="select1"
          :config="trainings"
          @setSelectedOption="setTraining($event);"
        ></SelectButton>
        <div class="submitParrent">
          <input type="submit" class="submitButton" value="GO" @click="func()">
        </div>
      </div>
      <div class="content2">
        <span>
          Personal
          <br />Development
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import SelectButton from "@/components/home-components/SelectButton.vue";
export default {
  components: {
    SelectButton,
  },
  data() {
    return {
      //this is for the 1st selector
      workshops: {
        options: [
          {
            value: "Personal Development",
          },
          {
            value: "Career Development",
          },
        ],
        placeholder: "Alege Domeniul",
        textColor: "#F37298",
        borderRadius: "2em",
        border: "1px solid gray",
        width: 350,
      },

      //this will change by the state of the 1st selector
      trainings: {
        options: [
          {
            value: "Creative Thinking",
          },
          {
            value: "Time Management",
          },
          {
            value: "Self Understanding",
          },
          {
            value: "How to learn efficiently",
          },
          {
            value: "Public Speaking",
          },
          {
            value: "Emotional Intelligence",
          },
          {
            value: "Stress Management"
          }
        ],
        placeholder: "Alege un training",
        backgroundColor: "white",
        textColor: "#F37298",
        borderRadius: "1.5em",
        border: "1px solid gray",
        width: 350,
      },
      //arrays with Personal trainings and Career trainings used to change the 2nd selector
      PersonalOptions:[
        {
            value: "Creativity & Creative Thinking",
          },
          {
            value: "Time Management",
          },
          {
            value: "Self Understanding",
          },
          {
            value: "How to learn efficiently",
          },
          {
            value: "Public Speaking",
          },
          {
            value: "Emotional Intelligence",
          },
          {
            value: "Stress Management"
          }
      ],
      CareerOptions: [
        {
            value: "Career guidance",
          },
          {
            value: "Job Interview",
          },
          {
            value: "Negotiation Skills",
          },
          {
            value: "How to reach your full potential",
          },
          {
            value: "Strategic Thinking",
          },
          {
            value: "Assertion",
          },
          {
            value: "Problem Solving"
          }
      ],
    };
  },
  methods: {
    setTraining(selectedOption) {
      this.trainings.placeholder = selectedOption.value;
    },
    setWorkshop(selectedOption) {
      this.workshops.placeholder = selectedOption.value;
      if(selectedOption.value === "Personal Development") {
        //i = numarul de training uri per workshop
        for(let i = 0; i < 7; ++i) {
          this.$set(this.trainings.options, i, this.PersonalOptions[i]);
        }
      } else {
        for(let i = 0; i < 7; ++i) {
          this.$set(this.trainings.options, i, this.CareerOptions[i]);
        }
      }
    },
    func() {
      // this.$router.push({ path: 'about' })
      if(this.trainings.placeholder !="Alege un training")
        this.$router.push({ name: 'FakeTrainings', params: { id: this.trainings.placeholder}});
      // location.href= this.trainings.placeholder;
      //this will be used to jump to the selected training, found at this.trainings.placeholder, in cazul in care nu va puteti folosi de el
      //faceti 14 if-uri pentru fiecare training (desi nu cred ca e cazul de asemenea pacat)

      // document.getElementById('training-right-6').scrollIntoView({
      //   behavior: 'smooth'
      // });
      // ^ nu functioneaza intre componente
    },
    dothis() {
      
    }
  },
};
</script>

<style scoped lang="scss">
//variables
$svg-width: 31vw;
$svg-padding: calc(30vw * 6 / 4); //nu poti pune variabile in calc()
$svg-displacement: -1vw; //ca sa nu apara marginea

#mediahero {
  width: 100%;
  overflow: hidden;
  background-color: #0d2a4c;
  background-size: cover;
  background-position: center;
  position: relative;
  padding-top: 10vh;
}

// content
.flex-container {
  padding-bottom: 10vh;
  display: flex;
  width: 100vw;
  justify-content: space-between;
  align-items: center;
}

.content {
  position: relative;
  bottom: -10vh;
  background-image: url("../../assets/images/left svg.svg");
  background-size: cover;
  width: $svg-width;
  padding: 0;
  padding-bottom: $svg-padding;
  left: -1vw + $svg-displacement;
}

.content2 {
  position: relative;
  background-image: url("../../assets/images/right svg.svg");
  background-size: cover;
  width: $svg-width;
  padding: 0;
  padding-bottom: $svg-padding;
  right: $svg-displacement;
  
}

div > span {
  font-family: "Acumin Variable Concept";
  font-size: 3vw;
  position: absolute;
  text-align: center;
}

.content > span {
  top: 45%;
  left: 20%;
}

.content2 > span {
  top: 20%;
  right: 10%;
}

// text

.textsMobile{
  display:none;
}
p, span {
  color: #edf6fb;
}
.texts {
  left: 10vw;
  position: absolute;
}
.text1 {
  width: 100%;
  margin-bottom: 1vh;
}

.text1 > p {
  font: 2.18vw Century;
}

.text2 > p {
  font: 2.5vw Century;
}

// buttons
.selection {
  position: relative;
}

.buttons {
  display: flex;
  justify-content: center;
}

.select2 {
  margin-bottom: 5%;
  position: relative;
  right: -1%;
}


.submitButton {
    width: calc(4vh*2);
    height: 4vh;
    margin-top: 5%;
    position: relative;
    float: right;
    display: block;
    text-align: center;
    background: whitesmoke 0% 0% no-repeat padding-box;
    border: 1px  #707070;
    border-radius: 55px;
    opacity: 1;
    font-size: 1vw;
    font-weight: bold;
    letter-spacing: 0px;
    color: #F37298;
  }

  input[value="GO"]{
    vertical-align: middle;
  }
  
 @-moz-document url-prefix() { 
    .submitButton {
      display: flex;
      align-items: center;
      justify-content: center;
       // text-align: center;
      line-height: normal;
        
    }
}

//aici puteti sa mai modificati pentru dimensiunile foarte mari
@media screen and (min-width: 1920px) {
  .selection {
    transform: scale(2);
  }
}

@media screen and (min-width: 2560px) {
  .selection {
    transform: scale(2.7);
  }
}

@media screen and (min-width: 3200px) {
  .selection {
    transform: scale(3.5);
  }
}

@media screen and (max-width: 1023px) {
  $svg-width-mobile: 62vw;
  $svg-padding-mobile: calc(62vw * 5.83 / 4);

  #media-hero {
    padding: 0;
  }
  
  .flex-container {
    flex-wrap: wrap;
    justify-content: normal;
  }
  

  .selection {
    transform: scale(0.8);
    text-align:center;
    display: flexbox;
  }

  .content,
  .content2 {
    width: $svg-width-mobile;
    padding: 0;
    padding-bottom: $svg-padding-mobile;
  }

  .content {
    left: -3.4vw;
    margin-bottom:0vh;
  }

  .content2 {
    right: -102vw + $svg-width-mobile;
    //left: 1vw + $svg-width-mobile;
  }

  div > span {
    font-size: 6vw;
  }

  .content > span {
    left: 15%;
  }

  .content2 > span {
    top: 25%;
  }

  .textsMobile{
    display: block;
  }

  .texts {
    left: 0;
    top: 70vh;
    display: none;
  }

  .text2M {
    width: 100vw;
  }

  .text1M > p {
    text-align: center;
    font-size: 4.2vw;
    font-family: Century;
    padding-top: 3vh;
  }

  .text2M > p {
    text-align: center;
    font-size: 5vw;
    font-family: Century;
    font-weight: bold;
  }
  
  .submitButton{
    //position: relative;
    //float: right !important;
    //display: block;
    text-align: center;
    
    
  }

  
}

@media screen and (max-width: 700px) {

.submitButton {
  height: 4.2vh;
  width: calc(4.2vh*2);
  font-size: 3vw;

}

input[value="GO"]{
    vertical-align: middle;
  }
  

@media screen and (max-width: 420px) {
  .selection{
    margin-top: 10vh;
    left: 2.5vw;
    
  }
  .submitParrent{
    width:353px;
  }
  .submitButton{
    align-self: right;

  }
}

@media screen and (max-width: 330px) {
  .selection{
    left: -3vw;
  }
}

@media screen and (min-width: 1900px) {
.submitButton {
  height: 3vh;
  width: calc(3vh*2);
}
}
}

</style>
